import { environment } from '@/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import { Certificado } from '@/app/models/interface/certificado.model';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class CertificadoService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'certificado/';

  create(data: FormData) {
    return this.http.post<CustomResponse<Certificado>>(this.url, data).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;

        return {
          ...d,
        };
      }),
    );
  }

  findAll(
    params?: HttpParams,
  ): Observable<PaginatorModel<Certificado[], HasPagination>> {
    return this.http
      .get<
        CustomResponse<PaginatorModel<Certificado[], HasPagination>>
      >(this.url, { params })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;

          if (d && Array.isArray(d.data)) {
            return {
              ...d,
              data: d.data.map((certificado) => {
                return {
                  ...certificado,
                };
              }),
            };
          }
          return d;
        }),
      );
  }

  findOne(id: string) {
    const url = this.url + id;
    return this.http.get<CustomResponse<Certificado>>(url).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        if (d) {
          return {
            ...d,
          };
        }
        return d;
      }),
    );
  }

  update(certificado: Partial<Certificado>) {
    const url = this.url + certificado.id;
    return this.http.put<CustomResponse<Certificado>>(url, certificado).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        if (d) {
          return {
            ...d,
          };
        }
        return d;
      }),
    );
  }

  changeState(vigente: boolean, id: string) {
    const url = this.url + id;
    return this.http.patch<CustomResponse<Certificado>>(url, { vigente }).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        if (d) {
          return {
            ...d,
          };
        }
        return d;
      }),
    );
  }
}
